module.exports = __webpack_public_path__ + "static/media/Logo.aa509acc.png";